import { Component, OnInit } from '@angular/core';
import { Contact } from './contact';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {

  name = '';
  email = '';
  subject = '';
  request = '';

  constructor() { }

  contactEmailSubject() {
    return(this.subject);
  }

  contactEmailBody() {
    const r = 'Hallo Digital-Dividend Team,' + '%0D%0A' +
      'mein Name ist ' + this.name + ' (' + this.email + ')'+ '%0D%0A' +
      'Meine Anfrage:' + '%0D%0A' + this.request;
    return(r);
  }

  ngOnInit() {
  }

}
